import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.0399 4.27327C13.2644 4.04872 13.2644 3.68465 13.0399 3.4601C12.8153 3.23555 12.4513 3.23555 12.2267 3.4601L8.49996 7.18685L4.77321 3.4601C4.54866 3.23555 4.18459 3.23555 3.96004 3.4601C3.73549 3.68465 3.73549 4.04872 3.96004 4.27327L7.68679 8.00002L3.96004 11.7268C3.73549 11.9513 3.73549 12.3154 3.96004 12.5399C4.18459 12.7645 4.54866 12.7645 4.77321 12.5399L8.49996 8.81319L12.2267 12.5399C12.4513 12.7645 12.8153 12.7645 13.0399 12.5399C13.2644 12.3154 13.2644 11.9513 13.0399 11.7268L9.31313 8.00002L13.0399 4.27327Z",
		fill: "currentColor"
	})
});
export default SvgCloseIcon;
